import { render, staticRenderFns } from "./factures_service_okba_non_paye.vue?vue&type=template&id=58f587b8&"
import script from "./factures_service_okba_non_paye.vue?vue&type=script&lang=js&"
export * from "./factures_service_okba_non_paye.vue?vue&type=script&lang=js&"
import style0 from "./factures_service_okba_non_paye.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports